import { useLogin, useNotify, Title } from "react-admin";
import { parse } from "query-string";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { useLocation } from "react-router-dom";

const Login = () => {
  const { search } = useLocation();
  const { at: authToken, referrer } = parse(search);
  const login = useLogin();
  const notify = useNotify();

  if (authToken) {
    login({ token: authToken, referrer }).catch(() => notify("Invalid token"));
  }

  return (
    <Card>
      <Title title="Login" />
      <CardContent>
        Please get your Auth Token from Admin and redirect to React Content
        Admin
      </CardContent>
    </Card>
  );
};

export default Login;
